import React from 'react';
import { View, Keyboard, StyleProp, ViewStyle } from 'react-native';

type Props = {
  style?: StyleProp<ViewStyle>;
};

class Form extends React.Component<Props> {
  inputs = [];
  constructor(props) {
    super(props);
    this.inputs = [];
  }

  renderChildren(children, recursiveIndex = 0) {
    return React.Children.map(children, (child, index) => {
      // if (child.type.displayName !== 'withTheme(TextInput)') {
      //   console.log('child.type', child.type);
      // }

      if (!child || !child.type) {
        return child;
      }
      if (child.props && child.props.children) {
        return React.cloneElement(child, {
          ...child.props,
          children: this.renderChildren(child.props.children, index)
        });
      }
      // console.log('child.type.displayName', child.type.displayName);
      if (child.type.displayName !== 'withTheme(TextInput)') {
        return child;
      }

      let realIndex = index + recursiveIndex;
      return React.cloneElement(child, {
        onSubmitEditing: () => {
          const findNextInput = () => {
            for (let i = realIndex + 1; i < this.inputs.length; i++) {
              const input = this.inputs[i];
              if (input && input.props && input.props.disabled !== true) {
                return i;
              }
            }
            return -1;
          };
          const nextIndex = findNextInput();
          if (nextIndex === -1) {
            Keyboard.dismiss();
          } else {
            this.inputs[nextIndex].focus();
          }
        },
        ref: (ref) => (this.inputs[realIndex] = ref),
        blurOnSubmit: false
      });
    });
  }

  render() {
    let { children, ...props } = this.props;
    return <View {...props}>{this.renderChildren(children)}</View>;
  }
}

export default Form;
